import { AR_BUCKET } from "src/app/constants";
import { Patient } from "../tenants/patient.models";

export class PaymentsReportsReqCommand {
  period: string;
  startDate: Date | null;
  endDate: Date | null;
  practiceId: number;
  customerId: number;
}

export class SendPaymentLinkReport {
  transactionId: number;
  patientId: number;
  patientName: string;
  practiceId: number;
  id: number;
  amount: string;
  status: string;
  createDate: string;
  finalPaymentStatusName: string;
}

export class SendPaymentLinkReportResponse {
  sendPaymentLinkReport: SendPaymentLinkReport[];
  totalRecords: number;
}

export class SendPaymentLinkReportReqCommand {
  searchTerm: string = '';
  sortBy: number = 2;
  pageNumber: number = 1;
  pageSize: number = 15;
  practiceId: number = 0;
  customerId: number = 0;
  payNowLookUpType?: number = 0;
  period?: string = '';
  startDate?: Date | null;
  endDate?: Date | null;
  moduleReportId: number;
}

export class WriteBackRetryReportReqCommand {
  customerId: number;
  practiceId: number;
  period?: string;
  startDate?: string;
  endDate?: string;
  isSuccess?: any[] | null;
  transactionCollectionTypes?: any[] | null;
  transactionTypes?: any[] | number;
  moduleIds?: any[] | null;
  writeBackStatuses?: any[] | null;
  searchTerm: string;
  sortBy: number;
  sortFieldName: string;
  pageNumber: number;
  pageSize: number;
  isWriteBackRetry?: boolean | null;
  timeZoneId?: string;
}

export class AdvancedFilterWriteBackRetryReport {
  startDate?: string | null;
  endDate?: string | null;
  isSuccess?: any[] | null;
  transactionCollectionTypes?: any[] | null;
  transactionTypes?: any[] | null;
  moduleIds?: any[] | null;
  writeBackStatuses?: any[] | null;
  isWriteBackRetry?: boolean | null;
}

export class AdvancedFilterPPReport {
  patientId: string = '';
  patientName: string = '';
  paymentPlanName: string = '';
  templateName: string = '';
  amountDue: number | null = null;
  amountOperator: string = '1';
  isOpenInstallments: boolean = false;
  paymentPlanStatuses: any[] | null = null;
}

export class TransactionHistoryReport {
  transactionId: number;
  patientId: number;
  patientName: string;
  practiceId: number;
  id: number;
  amount: string;
  createDate: string;
  status: string;
  transactionType: number;
  paymentMethod: string;
  transactionTypesName: string;
  transactionCollectionType: number;
  statusValue: string;
  isSuccess: boolean;
}
export class TransactionHistoryReportResponse {
  transactionHistoryReport: TransactionHistoryReport[];
  totalRecords: number;
}

export class FailedPaymentsReport {
  transactionId: number;
  patientId: number;
  patientName: string;
  practiceId: number;
  id: number;
  amount: string;
  createDate: string;
  status: string;
  TransactionTypes: number;
  retriedTransactionId?:number;
  fixIt?: string;
}
export class FailedPaymentsReportResponse {
  failedPaymentsReport: FailedPaymentsReport[];
  totalRecords: number;
}

export class PayNowReport {
  transactionId: number;
  patientId: number;
  patientName: string;
  practiceId: number;
  id: number;
  amount: string;
  createDate: string;
  status: string;
  transactionTypes: number;
  phone: string;
  writeBackStatus: boolean;
  writeBackStatusText: string;

  pmsPatientName: string;
  pmsPatientId: number;
  pmsAmountDue: string;
  pmsPhone: string;
  mapPost: string;
  paymentMethodName: string;
  payNowLookUpTypeName: string;
  payNowLookUpType: number;
  matchedPatients?:Patient[];
  isPatientIds:string;
  mapStatus?:string;
  isTransactionMatching?:boolean;
}
export class PayNowReportResponse {
  payNowReport: PayNowReport[];
  totalRecords: number;
}

export class OverallTrendReport {
  patientId: number;
  patientName: string;
  transactionCollectionType: number;
  transactionCollectionTypeName: string;
  moduleId: number;
  moduleName: string;
  paymentCollectedDate: string;
  amount: string;
}
export class OverallTrendReportResponse {
  overallTrends: OverallTrendReport[];
  totalRecords: number;
}

export class CCPaymentTrendReport {
  patientId: number;
  patientName: string;
  cardType: string;
  moduleId: number;
  moduleName: string;
  paymentCollectedDate: string;
  amount: string;
}
export class CCPaymentTrendReportResponse {
  ccPaymentTrends: CCPaymentTrendReport[];
  totalRecords: number;
}

export class PaymentAnalyticsReport {
  patientId: number;
  patientName: string;
  transactionType?: number;
  transactionTypeName: string;
  totalCount: string;
  percentageOfTotalCount: string;
  totalAmount: string;
  percentageOfTotalAmount: string;
  paymentCollectedDate: string;
}
export class PaymentAnalyticsReportResponse {
  paymentAnalytics: PaymentAnalyticsReport[];
  totalRecords: number;
}

export class WriteBackRetryReportResponse {
  writeBackRetryReport: WriteBackRetryReport[];
  totalRecords: number;
}

export class WriteBackRetryReport {
  practiceId: number;
  transactionId: number;
  id: string;
  patientId: number;
  patientName: string;
  amount: number;
  createDate: string;
  transactionCollectionType: number;
  transactionCollectionTypeName: string;
  transactionType: number;
  transactionTypeName: string;
  moduleId: number;
  moduleName: string;
  cardType: string;
  isSuccess: boolean;
  writeBackStatus: number;
  writeBackStatusName: string;
  writeBackMessageId: string;
  writeBackLastRetryOn: string;
  writeBackLastRetryBy: string;
  billing?: any;
  note?: any;
  paymentMode?: string;
  displayMessage?: string;
  errorMessage?: string;
  emiTransactionType: number;
  emiTransactionTypeName?: string;
}

export class ExportExcelReqCommand {
  sortBy: number = 2;
  practiceId: number = 0;
  moduleReportId: number;
  period: string;
  startDate: Date | null;
  endDate: Date | null;
  payNowLookUpType?: number = 0;
  isActive?: boolean = true;
  isShowByProvider?: boolean = false;
  paymentAge?: AR_BUCKET = AR_BUCKET.None;
}
